export default __webpack_public_path__ + "static/media/ClickMix.64c550e2.svg";